module.exports = __webpack_public_path__ + "img/playbar_play_grey.e00bbc65.svg";